import { render, staticRenderFns } from "./GoogleLogo.vue?vue&type=template&id=2a7e0a98&"
import script from "./GoogleLogo.vue?vue&type=script&lang=js&"
export * from "./GoogleLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports